"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getData(docs, onlyIds) {
    if (onlyIds) {
        return docs.map(function (doc) { return doc.id; });
    }
    return docs.map(function (doc) { return ({
        id: doc.id,
        data: doc.data(),
    }); });
}
exports.default = getData;
//# sourceMappingURL=getData.js.map